import moment, {Moment} from 'moment-timezone'

import type {MomentRange} from '../types'

const startEndParamFormat = 'YYYY-MM-DDTHH'

export const convertToURLDatetime = (datetime: Moment, timezoneId: string) =>
  datetime.clone().tz(timezoneId).format(startEndParamFormat)

export const parseStartEndDatetimeFromURLParams = ({
  start: startParam,
  end: endParam,
  timezoneId
}: {
  start: string | null
  end: string | null
  timezoneId: string
}): MomentRange | undefined => {
  const parsedStart = startParam !== null ? moment.tz(startParam, timezoneId).utc() : undefined
  const parsedEnd = endParam !== null ? moment.tz(endParam, timezoneId).utc() : undefined
  const areStartAndEndExist = parsedStart && parsedEnd
  if (
    !areStartAndEndExist ||
    !parsedStart.isValid() ||
    !parsedEnd.isValid() ||
    parsedEnd.isSameOrBefore(parsedStart)
  ) {
    return undefined
  }
  return [parsedStart, parsedEnd]
}
